import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: `1px solid ${theme.props.border.primary.main}`,
    [theme.breakpoints.up('sm')]: {
      borderBottom: 'none',
    },
  },
  paper: {
    borderRadius: 5,
    width: '100%',
    display: 'flex',
    alignItems: 'center',

    border: 'none',
    padding: 0,
    [theme.breakpoints.up('sm')]: {
      border: `2px solid #FED278`,
      padding: '0.5em',
    },
  },
  count: {
    flex: 'none',
    display: 'inline-block',
    width: '2.0em',
    height: '2.0em',
    lineHeight: '2.0em',
    borderRadius: '50%',
    backgroundColor: '#FED278',
    textAlign: 'center',

    margin: '0 1.0em 0 0',
    [theme.breakpoints.up('md')]: {
      margin: '0 0.5em 0 0.2em',
    },
  },
  text: {
    width: '100%',
  },
}));

const SkillCard = ({ skill }) => {
  const { name, count } = skill;
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6} className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <div className={classes.count}>{count}</div>
        <span className={clsx('line-truncate-line-1', classes.text)}>
          {name}
        </span>
      </Paper>
    </Grid>
  );
};

SkillCard.propTypes = {
  skill: PropTypes.shape({
    name: PropTypes.string,
    count: PropTypes.number,
  }),
};

export default SkillCard;
